import React, { forwardRef, ButtonHTMLAttributes, Ref } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import RemoveIcon from 'Assets/images/icons/remove-icon.svg';

export interface RemoveFieldButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'icon' | 'icon-text' | 'filled';
}

const RemoveFieldButton = forwardRef(
  (
    { variant = 'icon', ...props }: RemoveFieldButtonProps,
    ref: Ref<HTMLButtonElement>,
  ) => (
    <button
      ref={ref}
      className={classNames(
        'interactModal__fieldBar-selectField-item-removeIcon-button',
        `interactModal__fieldBar-selectField-item-removeIcon-button--variant-${variant}`,
      )}
      {...props}
    >
      <ReactSVG
        src={RemoveIcon}
        className="interactModal__fieldBar-selectField-item-removeIcon"
      />
      {(variant === 'icon-text' || variant === 'filled') && 'Delete'}
    </button>
  ),
);

RemoveFieldButton.displayName = RemoveFieldButton.name;

export default RemoveFieldButton;
